import React, { useEffect, useState } from "react";
import {
  Button,
  FormFieldSet,
  showToast,
  useFormHandler,
} from "../../../../../components";
import { dateFormator } from "../../../../../utils";

import { useSelector } from "react-redux";
import { formatWords2 } from "../../../../../utils/stringUtils";
import { updateCompanyDetails } from "../../../../../redux/slices/accountDetails/accountDetailsAPi";

const EditModal = ({ onCancel, companyData, onSuccess }) => {
  const { user } = useSelector((state) => state.auth);
  const validationRules = {
    // website: {
    //   type: "text",
    //   required: true,
    // },
    // location: {
    //   type: "text",
    //   required: true,
    // },
    // industry: {
    //   type: "text",
    //   required: true,
    // },
  };
  const initialFormData = {
    website: companyData?.website || "",
    location: companyData?.location
      ? `${companyData?.location?.city || ""} - ${companyData?.location?.state || ""
      }`
      : "",
    industry: companyData?.industry || "",
    status: companyData?.status || 1,
    package: companyData?.package || "",
    amount: companyData?.amount || "",
    warrantyPeriod: companyData?.warranty || "",
    AgreementTerms: companyData?.agreementNetTerms || "",
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  const parseLocation = (loc) => {
    if (!loc) return null;

    if (typeof loc === "object" && loc.city && loc.state) return loc;

    if (typeof loc === "object" && loc.value) {
      const [cityRaw, stateRaw] = loc.value.split("-").map((p) => p.trim());
      return {
        city: cityRaw || null,
        state: stateRaw || null,
      };
    }

    if (typeof loc === "string") {
      const [cityRaw, stateRaw] = loc.split("-").map((p) => p.trim());
      return {
        country: "US",
        city: cityRaw || null,
        state: stateRaw || null,
      };
    }

    return null;
  };

  const handleSubmit = async () => {
    // const isValid = await validateAllFields();
    // if (!isValid) return;

    if (formData.package == 1) {
      if ((formData.amount == null || formData.amount == "" || formData.amount == undefined)) {
        showToast("Amount is Required.", "error");
        return;
      }
    }

    try {
      const locationObj =
        parseLocation(formData.location) || companyData.location || {};
      const payload = [
        {
          type: "SET",
          value: {
            website: formData.website,
            industry: formData.industry?.value || formData.industry,
            location: locationObj,
            status: Number(formData.status),
            modified: {
              by: user?.data?.uiid || 0,
              on: new Date().toISOString(),
            },
            package: Number(formData.package) || null,
            amount: formData.package == 1 ? Number(formData.amount) : null,
            warranty: Number(formData.warrantyPeriod) || null,
            agreementNetTerms: Number(formData.AgreementTerms) || null,
          },
        },
      ];

      const response = await updateCompanyDetails({
        coll: "Company",
        uiid: companyData?.uiid,
        payload,
      });

      if (response?.data) {
        showToast("Company details updated successfully", "success");
        onCancel();
        onSuccess?.();
      } else {
        showToast("Failed to update company details", "error");
      }
    } catch (error) {
      console.error("Error updating company details:", error);
      showToast("Failed to update company details", "error");
    }
  };

  return (
    <div className="flex flex-col gap-3 mb-5">
      <div className="flex items-center">
        <p className="text-black font-medium text-base">{formatWords2(companyData?.name)}</p>
        <span className="ms-2 me-5 text-[#9C9999] text-sm">
          ({dateFormator(companyData?.addedOn, "date-month-year")})
        </span>

        <div className="w-37">
          <FormFieldSet
            type="select"
            noTitle
            placeholder="Select"
            size="sm"
            options={[
              { label: "Active", value: 1 },
              { label: "Blocked", value: 2 },
            ]}
            value={formData.status}
            onChange={(value) => handleChange("status", value)}
          />
        </div>
      </div>

      <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 xl:me-20">
        <FormFieldSet
          title="Website"
          shadow={true}
          placeholder="Enter"
          value={formData.website}
          onChange={(value) => handleChange("website", value)}
          error={errors.website}
        />
        <FormFieldSet
          // type="select"
          type="citiesState"
          title="Location"
          placeholder="Select"
          // options={[
          //   { label: "Atlanta, Georgia", value: "Atlanta" },
          //   { label: "Austin, Texas", value: "Austin" },
          //   { label: "Boston, Massachusetts", value: "Boston" },
          //   { label: "Chicago, Illinois", value: "Chicago" },
          //   { label: "Dallas, Texas", value: "Dallas" },
          //   { label: "Las Vegas, Nevada", value: "Las Vegas" },
          //   { label: "Las Angeles, Nevada", value: "Las Angeles" },
          // ]}
          parentValue={{ country: "6807640e7ecb9f7d31314b7e" }}
          shadow={true}
          showSearch={true}
          value={formData.location}
          onChange={(value) => handleChange("location", value)}
          error={errors.location}
        />
      </div>
      <div className="grid grid-cols-2 lg:grid-cols-3 gap-5 xl:me-20">
        {/* <FormFieldSet
          title="Industry"
          shadow={true}
          placeholder="Enter"
          value={formData.industry}
          onChange={(value) => handleChange("industry", value)}
          error={errors.industry}
        /> */}
        <FormFieldSet
          type="industry"
          title="Select Industry"
          placeholder="Select Industry"
          options={[]}
          showButton
          showSearch
          value={formData.industry || ""}
          onChange={(value) => handleChange("industry", value)}
          error={errors.industry}
        />
        <FormFieldSet
          title="Package"
          type="select"
          placeholder="Select"
          options={[
            { label: "Flat", value: 1 },
            { label: "5%", value: 2 },
            { label: "10%", value: 3 },
            { label: "15%", value: 4 },
            { label: "20%", value: 5 },
          ]}
          value={formData.package}
          onChange={(value) => handleChange("package", Number(value))}
          error={errors.package}
        />
        {formData.package === 1 && (
          <FormFieldSet
            placeholder="Enter Amount"
            title="Amount"
            value={formData.amount}
            onChange={(value) => handleChange("amount", Number(value))}
          />
        )}
        <FormFieldSet
          title="Warranty Period"
          type="select"
          placeholder="Select"
          options={[
            { label: "30 days", value: 1 },
            { label: "60 days", value: 2 },
            { label: "90 days", value: 3 },
            { label: "120 days", value: 4 },
          ]}
          value={formData.warrantyPeriod}
          onChange={(value) => handleChange("warrantyPeriod", Number(value))}
          error={errors.warrantyPeriod}
        />

        <FormFieldSet
          title="Agreement Net Terms"
          type="select"
          placeholder="Select"
          options={[
            { label: "30 days", value: 1 },
            { label: "60 days", value: 2 },
            { label: "90 days", value: 3 },
            { label: "split(50-50)", value: 4 },
            { label: "split(25-25-25-25)", value: 5 },
            { label: "split(3 equal parts)", value: 6 },
          ]}
          value={formData.AgreementTerms}
          onChange={(value) => handleChange("AgreementTerms", Number(value))}
          error={errors.AgreementTerms}
        />
      </div>

      <div className="flex justify-end items-center gap-3 mt-30">
        <Button
          variant="outlined"
          title={"Cancel"}
          color="black"
          onClick={() => onCancel()}
        />
        <Button title={"Save"} onClick={handleSubmit} />
      </div>
    </div>
  );
};

export default EditModal;
